module.exports = __webpack_public_path__ + "static/media/one_time_payment.dd4f20a7.svg";